import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import HeadingBox from '../../UI/Headings/HeadingBox/HeadingBox';
import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import InputMaterial from '../../UI/InputMaterial/InputMaterial';
import Button from '../../UI/Button/Button';
import TextSpinner from '../../UI/TextSpinner/TextSpinner';
import TooltipError from '../../UI/TooltipError/TooltipError';

import * as authActions from '../../../store/actions/index';

class AuthSetPassword extends Component {

    state = {
        userPassword: '',
        userConfirmPassword: '',
        error: false
    }

    inputChangeHandler = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        this.setState({
            [name]: value
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.view !== nextProps.view) {
            this.props.history.push('/');
        }
    }

    keyPressHandler = (event) => {
        if(event.key === 'Enter' && (this.state.userConfirmPassword.trim() === this.state.userPassword.trim())) {
            this.props.onResetPassword(this.state.userConfirmPassword, (new URLSearchParams(this.props.location.search).get('recoveryToken')));
        }
    }

    render() {
        const params = new URLSearchParams(this.props.location.search);
        const recoveryToken = params.get('recoveryToken'); 
        return (
            <React.Fragment>
                <div className={`mb-6 u-phoneTextAlignCenter`}>
                    <HeadingBox>
                        <div className="mb-1">
                            <HeadingH2 size={26} weight="Regular" color="Dark">New Password!</HeadingH2>
                        </div>
                        <HeadingH3 size={13} weight="Regular" color="Light">Enter your new password adn then click on submit button to reset password.</HeadingH3>
                    </HeadingBox>
                </div>
                <div className={`u-flex align-items-center mb-2 u-height60 u-relative`}>
                    <TooltipError showTooltip={this.state.error} type="loginError" aria-label={'Password is not matching'} />
                    <InputMaterial 
                        type='password'
                        label='Password' 
                        alignment='left'
                        name='userPassword' 
                        value={this.state.userPassword}  
                        onChange={this.inputChangeHandler}
                        onKeyPress={this.keyPressHandler}/>
                </div>
                <div className={`u-flex align-items-center mb-2 u-height60 u-relative`}>
                    <TooltipError showTooltip={this.state.error} type="loginError" aria-label={'Password is not matching'} />
                    <InputMaterial 
                        type='password'
                        label='Confirm Password' 
                        alignment='left'
                        name='userConfirmPassword' 
                        value={this.state.userConfirmPassword}  
                        onChange={this.inputChangeHandler}
                        onKeyPress={this.keyPressHandler}/>
                </div>
                <div className={`mt-6`}>
                    <Button theme='Primary' width='Block' type='Login' onClick={() => this.props.onResetPassword(this.state.userConfirmPassword, recoveryToken)}>{this.props.passwordRecoveryLoading ? <TextSpinner type='White'/> : 'SUBMIT'}</Button>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        passwordRecoveryLoading: state.auth.passwordRecoveryLoading,
        view: state.auth.view
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onResetPassword: (newPassword, recoveryToken) => dispatch(authActions.resetPassword(newPassword, recoveryToken))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthSetPassword));


// WEBPACK FOOTER //
// ./src/components/Authentication/AuthSetPassword/AuthSetPassword.js